import ReactDOM from 'react-dom/client'; // ReactDOM for rendering React components
import './index.css'; // Global CSS styles
import App from './App'; // Main App component
import { BrowserRouter } from 'react-router-dom'; // Allows routing to different pages

/* Finds HTML element with id="root" in index.html and creates a root element */
const root = ReactDOM.createRoot(document.getElementById('root'));

/* Render the App inside the root div. App is wrapped in BrowserRouter for routing */
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
